import React, { forwardRef } from "react";

/**
 * Select - Dropdown riutilizzabile
 *
 * Props:
 * - label: string
 * - error: string
 * - helper: string
 * - options: Array di { value, label } o stringhe
 * - placeholder: string
 */
const Select = forwardRef(
  (
    {
      label,
      error,
      helper,
      options = [],
      placeholder = "Seleziona...",
      className = "",
      id,
      required,
      disabled,
      children,
      ...props
    },
    ref,
  ) => {
    const inputId = id || `select-${Math.random().toString(36).substr(2, 9)}`;

    // Normalizza opzioni
    const normalizedOptions = options.map((opt) =>
      typeof opt === "string" ? { value: opt, label: opt } : opt,
    );

    return (
      <div className={className}>
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        <div className="relative">
          <select
            ref={ref}
            id={inputId}
            disabled={disabled}
            className={`
            w-full rounded-lg border px-4 py-2 pr-10 appearance-none bg-white
            transition-colors cursor-pointer
            focus:ring-2 focus:ring-primary-500 focus:border-transparent
            disabled:bg-gray-100 disabled:cursor-not-allowed
            ${error ? "border-red-300 focus:ring-red-500" : "border-gray-300"}
          `}
            {...props}
          >
            {children != null ? (
              children
            ) : (
              <>
                {placeholder && (
                  <option value="" disabled>
                    {placeholder}
                  </option>
                )}
                {normalizedOptions.map((opt) => (
                  <option
                    key={opt.value}
                    value={opt.value}
                    disabled={opt.disabled}
                    title={opt.title || opt.label}
                  >
                    {opt.label}
                  </option>
                ))}
              </>
            )}
          </select>
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <svg
              className="h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        {helper && !error && (
          <p className="mt-1 text-sm text-gray-500">{helper}</p>
        )}
      </div>
    );
  },
);

Select.displayName = "Select";

export default Select;
